import { createFileRoute } from "@tanstack/react-router";
import { DashboardPage } from "@/pages/Dashboard";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Dashboard — AXIS Comprovantes" },
      { name: "description", content: "Visão geral das operações de extratos, lançamentos e comprovantes." },
    ],
  }),
  component: DashboardPage,
});
